import { type ELEMENT_TYPE } from 'shop-ui/constants';
import { type ViewportElementInfo } from './ViewportElementCollector';

const __debug_element_points: Map<ViewportElementInfo['id'], HTMLElement> = new Map();

export function __debug_mode_hide_element_center_func(id: ViewportElementInfo['id']) {
    const child = __debug_element_points.get(id);

    if (child) {
        document.body.removeChild(child);
    }

    __debug_element_points.delete(id);
}

export function __debug_mode_show_element_center_func(info: ViewportElementInfo) {
    __debug_mode_hide_element_center_func(info.id);

    const el = document.createElement('div');

    const elText = document.createElement('span');

    el.style.position = 'absolute';

    el.style.width = '5px';

    el.style.height = '5px';

    el.style.backgroundColor = 'red';

    el.style.left = `${info.x}px`;

    el.style.top = `${info.y}px`;

    el.style.zIndex = '99999999';

    elText.innerText = info.id;

    elText.style.whiteSpace = 'nowrap';

    el.appendChild(elText);

    document.body.appendChild(el);

    __debug_element_points.set(info.id, el);
}

export function calculateElementInfo(
    id: string,
    target: HTMLElement,
    type: ELEMENT_TYPE
) {
    const { top: y, left: x, width, height } = target.getBoundingClientRect();

    const elementCenterX = x + window.scrollX + width / 2;

    const elementCenterY = y + window.scrollY + height / 2;

    const info = {
        type,
        id,
        x: elementCenterX,
        y: elementCenterY,
        target,
    };

    return info;
}
